import React, { useMemo, useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import { FilterProps } from '../../common/filter.util';
import { ManageTypeFilter } from '../ManageTypeFilter';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { translate } from '../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import {
  isProductMasterDataManageType,
  ProductMasterDataManageType,
} from '../../../../../types/product_master_data/productMasterData';

interface ManageTypeFilterContentProps {
  filter: ManageTypeFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function ManageTypeFilterContent({ filter, filterProps, setFilterProps }: ManageTypeFilterContentProps) {
  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    return new Set(Object.values(ProductMasterDataManageType).filter(value => filter.search(value, query)));
  }, [filter, query]);

  const handleChange = (selected: Set<string>) => {
    const nextSelected = new Set<ProductMasterDataManageType>([...selected].filter(isProductMasterDataManageType));

    filterProps.manageType = nextSelected;
    if (!filterProps.manageType?.size) filterProps.manageType = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.manageType = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{filter.toLabel()}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.manageType}
          values={values}
          onChange={handleChange}
          toText={value =>
            isProductMasterDataManageType(value)
              ? ManageTypeFilter.toText(value)
              : translate({ key: TranslationKey.unknown })
          }
        />
      </Grid>
    </Grid>
  );
}
